import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { AppId } from 'constants/apps';

interface AppMeta {
	name: string;
	learnMoreUrl: string;
}

const APP_META: Record<AppId, AppMeta> = {
	candispatch: { name: 'CANdispatch', learnMoreUrl: 'https://streamdata.com/candispatch' },
	canvision: { name: 'CANvision', learnMoreUrl: 'https://streamdata.com/canvision' },
	canpark: { name: 'CANpark', learnMoreUrl: 'https://streamdata.com/canpark' },
	canshare: { name: 'CANshare', learnMoreUrl: 'https://streamdata.com/canshare' },
	cantrack: { name: 'CANtrack', learnMoreUrl: 'https://streamdata.com/cantrack' },
	canmail: { name: 'CANmail', learnMoreUrl: 'https://streamdata.com/canmail' },
	canmeet: { name: 'CANmeet', learnMoreUrl: 'https://streamdata.com/canmeet' },
	cansurvey: { name: 'CANsurvey', learnMoreUrl: 'https://streamdata.com/cansurvey' },
	canai: { name: 'CANai', learnMoreUrl: 'https://streamdata.com/canquery' },
};

const SALES_URL = 'https://streamdata.com/contact';

interface SubscribePromptProps {
	appId: AppId;
}

const SubscribePrompt: React.FC<SubscribePromptProps> = ({ appId }) => {
	const navigate = useNavigate();
	const meta = APP_META[appId];
	const appName = meta?.name ?? appId;

	return (
		<Box
			sx={{
				minHeight: '80vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				p: 3,
			}}
		>
			<Paper
				sx={{
					p: 5,
					maxWidth: 480,
					textAlign: 'center',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					gap: 2,
				}}
				elevation={3}
			>
				<LockIcon sx={{ fontSize: 56, color: 'text.secondary' }} />
				<Typography variant="h5" fontWeight="bold">
					{appName} isn't included in your plan
				</Typography>
				<Typography variant="body1" color="text.secondary">
					Your organization isn't subscribed to {appName}. Contact our team to
					add it to your plan.
				</Typography>
				<Box sx={{ display: 'flex', gap: 2, mt: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
					<Button
						variant="contained"
						onClick={() => window.open(SALES_URL, '_blank', 'noopener,noreferrer')}
					>
						Contact Sales
					</Button>
					{meta && (
						<Button
							variant="outlined"
							onClick={() => window.open(meta.learnMoreUrl, '_blank', 'noopener,noreferrer')}
						>
							Learn More
						</Button>
					)}
					<Button variant="text" onClick={() => navigate('/')}>
						Back to Home
					</Button>
				</Box>
			</Paper>
		</Box>
	);
};

export default SubscribePrompt;
